import React from "react";

const ArrowUp = props => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
    >
      <path d="M12 22V2M5 9l7-7 7 7" />
    </g>
  </svg>
);

export default ArrowUp;



// WEBPACK FOOTER //
// ./src/theme/icons/ArrowUp.js